module.exports = __webpack_public_path__ + "static/media/Lettuce2.e0090f97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/Lettuce2.jpg
// module id = 121
// module chunks = 0